import { useEffect, useRef, useState } from 'react';
import { isDebugMode } from 'utils/debug';
import { pingForUrlChange } from 'utils/url';

export const useUrlListener = (isInstance = false) => {
  const [url, setUrl] = useState(window.location.href);
  const ref = useRef<NodeJS.Timer>();

  const handleUrlChange = () => {
    if (isDebugMode()) {
      console.log('In handleUrlChange. URL has changed, setting new value:', window.location.href);
    }
    setUrl(window.location.href);
  };

  useEffect(() => {
    if (isInstance) {
      ref.current = pingForUrlChange(ref.current, handleUrlChange);
      return () => {
        clearInterval(ref.current);
      };
    }
  }, []);

  return { url };
};
